import React from 'react';
import {
  Button,
  MenuItem,
  Grid,
  TextField,
  CardContent,
  IconButton,
  Icon,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';


const useStyles = makeStyles({
  listButton: {
    margin: '0px 10px 0px 10px',
    height: '40px',
    width: '170px',
  },
  multilineInput: {
    '& .MuiOutlinedInput-multiline': {
      padding: 0,
    },
  },
});


const TopicContent = (props) => {
  const {
    content,
    elementIndex,
    handleChangeContentValue,
    handleChangeContentType,
    handeleChangeListValue,
    removeRowe,
    handeleRemoveContent,
    handleAddRow,
    handeleAddContent
  } = props;
  const classes = useStyles();

  return (
    <>
      <>
        <CardContent className="px-0 flex items-start">
          <TextField
            className="mx-2 min-w-200"
            select
            label="Content Type"
            variant="outlined"
            value={content.contentType}
            onChange={(event) => handleChangeContentType(elementIndex, event.target.value)}
          >
            <MenuItem value="image">Image</MenuItem>
            <MenuItem value="generalText">General Text</MenuItem>
            <MenuItem value="boldText">Bold Text</MenuItem>
            <MenuItem value="title">Title</MenuItem>
            <MenuItem value="video">Video</MenuItem>
            <MenuItem value="boldStepsList">Steps List Bold</MenuItem>
            <MenuItem value="stepsList">Steps List</MenuItem>
            <MenuItem value="importantText">Important Text</MenuItem>
          </TextField>
          {content.contentType?.includes('List') ?
            <div className="w-full">
              {content.value.map((row, idx) => (
                <div key={idx} className="w-full flex mb-5">
                  <TextField
                    required
                    className="w-full"
                    label="Content value"
                    variant="outlined"
                    value={row}
                    onChange={(event) => handeleChangeListValue(elementIndex, idx, event.target.value)}
                  />
                  <Button
                    variant="outlined"
                    className={classes.listButton}
                    color="primary"
                    onClick={() => removeRowe(elementIndex, idx)}
                  >
                    <span className="capitalize">Remove Row</span>
                  </Button>
                </div>
              ))}
              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleAddRow(elementIndex)}
              >
                <span className="capitalize">Add Row</span>
              </Button>
            </div>
            :
            <>
              <TextField
                multiline
                required
                className={clsx(classes.multilineInput, 'w-full')}
                label="Content value"
                variant="outlined"
                value={content.value}
                onChange={(event) => {
                  handleChangeContentValue(elementIndex, event.target.value);
                }}
              />
            </>
          }
          <div className="flex items-center">
            <IconButton
              onClick={() => handeleRemoveContent(elementIndex, content)}
              title="Delete"
            >
              <Icon>delete</Icon>
            </IconButton>
            <IconButton
              onClick={() => handeleAddContent(elementIndex)}
              title="Add"
            >
              <Icon>add</Icon>
            </IconButton>
          </div>
        </CardContent>
        <Grid item xs={12}>
          {(elementIndex !== (elementIndex + 1)) && <Divider className="my-5" />}
        </Grid>
      </>
    </>
  );
};

export default React.memo(TopicContent, (prevProps, newProps) => {
  return JSON.stringify(prevProps.content) === JSON.stringify(newProps.content);
});
